<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import Chart from '@/components/charts/Chart'

export default {
  name: 'MonthlyCostByAdtypeChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    },
    labelField: {
      type: String,
      default: 'costMonth'
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.report?.map(item => item[this.labelField]),
        datasets: [
          {
            type: 'bar',
            label: 'SA',
            data: this.report?.map(item => item.sa),
            yAxisID: 'barChart'
          },
          {
            type: 'bar',
            label: 'DSP',
            data: this.report?.map(item => item.dsp),
            yAxisID: 'barChart'
          }
        ]
      }
    },
    options () {
      return {
        plugins: {
          legend: {
            display: true,
            reverse: false
          },
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                return `${label}: \xA5${value}`
              }
            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true
          },
          barChart: {
            stacked: true,
            ticks: {
              callback (value) {
                return `\xA5${value.toLocaleString()}`
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
